module.exports = __webpack_public_path__ + "static/img/avatar_img.fe16601.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar_img.jpg
// module id = wrQs
// module chunks = 1